import axios from 'axios';
import { Notistack } from '../../../../shared/components/Notistack/Notistack';
import { ILenderListItem } from '../shared/LenderControlsHeader';

const path = '/lender-service/lenders';

export const requestInactivateLenderCard = async (data: ILenderListItem) => {
  try {
    const resp = await axios.patch(`${path}/${data.id}/inactivate-active-cards`);
    Notistack.successMessage('Lender - Inactivated Successfully');
    return resp;
  } catch (err) {
    const error = err as { response: { data: { message: string } } };
    Notistack.generalError(error?.response?.data?.message);
  }
};